// @ts-strict-ignore
import { Material } from 'three';
import { StringUtils } from '@shared/util/string-utils';
import { ArticleVO } from '@article/model/vo/article.vo';
import { IArticleTextureParameters } from './i-article-texture-parameters';
import { IsThreeJsType } from '@3d-scene/common/util/is-threejs-type';

export class DefaultArticleTextureParameters implements IArticleTextureParameters {
  public static readonly DEFAULT_ARTICLE_PREFIX: string = 'articleTexture:';
  public static readonly KEY_ARTICLE_ID: string = 'id';
  public static readonly KEY_ARTICLE_VERSION: string = 'version';
  public static readonly KEY_TEXTURE_NAME: string = 'texture';

  private _textureName: string;
  private _specularName: string;
  private _normalName: string;
  private _articleId: number;
  private _articleVersion: number;

  constructor(material: Material, article: ArticleVO) {
    const name = (material as any).hasOwnProperty('map') && (material as any)['map'].name ? (material as any)['map'].name : material.name;
    this._textureName = StringUtils.getFileNameFromUrl(name) + '.png';
    const materialObject = material as any;
    if (materialObject.hasOwnProperty('specularMap') && IsThreeJsType.texture(materialObject['specularMap'])) {
      this._specularName = StringUtils.getFileNameFromUrl(materialObject['specularMap'].name);
    }
    if (materialObject.hasOwnProperty('normalMap') && IsThreeJsType.texture(materialObject['normalMap'])) {
      this._normalName = StringUtils.getFileNameFromUrl(materialObject['specularMap'].name);
    }
    this._articleId = article.identity;
    this._articleVersion = article.version;
  }

  public getPrefix(): string {
    return DefaultArticleTextureParameters.DEFAULT_ARTICLE_PREFIX;
  }

  public getTextureParameters(): string {
    return this.getParameterByTextureName(this._textureName);
  }

  public getSpecularMapParameters(): string {
    return this.getParameterByTextureName(this._specularName);
  }

  public getNormalMapParameters(): string {
    return this.getParameterByTextureName(this._normalName);
  }

  public getTextureExtension(): string {
    return this.getExtensionByTextureName(this._textureName);
  }

  public getSpecularExtension(): string {
    return this.getExtensionByTextureName(this._specularName);
  }

  public getNormalExtension(): string {
    return this.getExtensionByTextureName(this._normalName);
  }

  private getParameterByTextureName(name: string): string {
    if (!name) {
      return null;
    }
    const parametersString: string = `version=${this._articleVersion}&texture=${name}&id=${this._articleId}`;
    return this.getPrefix() + parametersString;
  }

  private getExtensionByTextureName(name: string): string {
    return name == null ? null : StringUtils.getFileSuffix(this._textureName);
  }
}
